// extracted by mini-css-extract-plugin
export default {"fileUploadHeader":"FileUploadHeader_fileUploadHeader__rW8BJ","copyright":"FileUploadHeader_copyright__Wqkgy"};